import { FC } from "react";
import { Text } from "@mantine/core";

import { Issue } from "@protos/issues/v1/issues";
import { HoverCopyButton } from "@shared/components";

import { useScaHumanReadableIssueName } from "../../../hooks/useScaHumanReadableIssueName";

export interface RuleTitleProps {
  finding: Issue;
}

export const ScaRuleTitle: FC<RuleTitleProps> = ({ finding }) => {
  const scaRuleTitle = useScaHumanReadableIssueName(finding);
  return (
    <HoverCopyButton
      copyText={finding.rulePath}
      tooltipText="Copy full rule name"
      iconSize="lg"
    >
      <Text lineClamp={1} size="lg" fw={700}>
        {scaRuleTitle}
      </Text>
    </HoverCopyButton>
  );
};
